import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContextualMenuChange } from '../models/contextual-menu-change';

@Injectable({
    providedIn: 'root',
})
export class ContextualMenuService<T, U> {
    public contextualMenuSubject = new BehaviorSubject<ContextualMenuChange<T, U>>(null);

    public selectionChange(change: ContextualMenuChange<T, U>) {
        this.contextualMenuSubject.next(change);
    }
}
